import { useNavigate } from "react-router-dom";
import { PhysicianDashboardView } from "@/features/physician/review-queue/components/PhysicianDashboardView";

export function PhysicianDashboardPage() {
  const navigate = useNavigate();
  return <PhysicianDashboardView onOpenItem={(id) => navigate(`/physician/review/${encodeURIComponent(id)}`)} />;
}
